<template>
  <div>
    <Popover class="relative">
      <PopoverButton>
        <div
          :class="['w-fit px-4 sm:px-6 h-6 sm:h-10 flex items-center justify-center text-xs sm:text-sm font-bold rounded-full transition-colors whitespace-nowrap relative', isDetail ? 'text-bolder bg-transparent border border-primary-dark hover:border-primary-dark-hover focus:border-primary-dark-hover' : 'text-heading bg-transparent border border-tag-border hover:border-tag-border-hover focus:border-tag-border-hover']">
          <div class="flex items-center mr-4">
            {{ $t('text-sort-by') }}
          </div>
          <ClientOnly>
            <button
              type="button"
              :class="['cursor-pointer h-full w-8 flex items-center justify-center absolute transition-colors duration-200 focus:outline-none end-1 sm:end-2', isDetail ? 'text-bolder hover:text-primary-light-hover focus:text-primary-light-hover' : 'text-selected-item hover:text-selected-item-hover focus:text-selected-item-hover']"
              :aria-label="$t('text-burger-menu')"
            >
              <ChevronDown class="w-3 h-3 sm:w-4 sm:h-4" />
            </button>
          </ClientOnly>
        </div>
      </PopoverButton>
      <Transition
enter-active-class="transition duration-200 ease-out" enter-from-class="translate-y-1 opacity-0"
        enter-to-class="translate-y-0 opacity-100" leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100" leave-to-class="translate-y-1 opacity-0">
        <PopoverPanel v-slot="{ close }" class="absolute right-0 mt-2 py-4 w-44 bg-light rounded-xl shadow-700 z-20">
          <Scrollbar class-name="w-full h-full" :options="{ scrollbars: { autoHide: 'never' } }">
            <ul>
              <li v-for="({label, sort, direction}) in options" :key="`${sort}_${direction}`">
                <button
                  :class="[ 'block w-full py-2 px-6 text-sm text-start font-semibold transition duration-200 hover:text-accent focus:outline-none', _.get(route.query, 'sort', defaults.sort) === sort && _.get(route.query, 'direction', defaults.direction) === direction ? 'text-accent hover:text-accent-hover' : 'text-bolder hover:text-accent-hover' ]"
                  @click="handleClick(sort, direction, close)"
                >
                  {{ $t(label) }}
                </button>
              </li>
            </ul>
          </Scrollbar>
        </PopoverPanel>
      </Transition>
    </Popover>
  </div>



</template>

<script setup>
import _ from 'lodash-es';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { CATEGORY_TYPE } from "@utils/constants";
import Scrollbar from "@components/ui/scrollbar";
import ChevronDown from "@components/icons/outline/chevron-down";

const props = defineProps({
  type: {
    type: String,
    default: 'eshop'
  },
  isDetail: {
    type: Boolean,
    default: false
  }
});

const route = useRoute();

const defaults = ref({
  sort: props.type === CATEGORY_TYPE.NEWS ? 'order' : 'publishedAt',
  direction: 'desc'
});

const options = ref(props.type === CATEGORY_TYPE.ESHOP ? [
  { label: 'text-sort-by-newest', sort: 'publishedAt', direction: 'desc' },
  { label: 'text-sort-by-oldest', sort: 'publishedAt', direction: 'asc' },
  { label: 'text-sort-by-cheapest', sort: 'price', direction: 'asc' },
  { label: 'text-sort-by-expensive', sort: 'price', direction: 'desc' },
  { label: 'text-sort-by-position', sort: 'order', direction: 'desc' },
] : [
  { label: 'text-sort-by-newest', sort: 'publishedAt', direction: 'desc' },
  { label: 'text-sort-by-oldest', sort: 'publishedAt', direction: 'asc' },
  { label: 'text-sort-by-position', sort: 'order', direction: 'desc' },
]);

const handleClick = async (sort, direction, close) => {
  const params = { ...route.query };
  if (sort === defaults.value.sort) {
    delete params['sort'];
  } else if (_.get(params, 'sort') != sort) {
    params.sort = sort;
  }
  if (direction === defaults.value.direction) {
    delete params['direction'];
  } else if (_.get(params, 'direction') != direction) {
    params.direction = direction;
  }
  await navigatorTo({
    path: route.path,
    query: params,
  });
  close();
}

</script>
